<template>
  <FormKit v-model="newsletterSubscriptionForm" type="form" :actions="false" @submit="handleNewsletterSubscription">
    <FormKit
      type="email"
      name="emailAdress"
      validation="required|email"
      validation-visibility="blur"
      :validation-messages="{
        required: t_('validation-invalid-email'),
        email: t_('validation-invalid-email'),
      }"
      :placeholder="t_('input-placeholder')"
      class="mt-5"
    />

    <div class="mb-4">
      <MoleculeRecaptchaDisclaimer />
    </div>
    <FormKit type="submit" :label="t_('button-text')" />
  </FormKit>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { newsletterSubscribe } from '@/assets/newsletter'

const props = defineProps({
  origin: { type: String, required: false, default: undefined },
  endpointPath: { type: String, required: false, default: undefined },
  url: { type: String, required: true },
})

const emit = defineEmits(['newsletter-subscribed'])

const config = useRuntimeConfig()
const { locale } = useI18n()
const { t_ } = setupTranslationPrefixer('newsletter')

const newsletterSubscriptionForm = ref({ emailAdress: '' })
const handleNewsletterSubscription = async () => {
  const emailAddress = unref(newsletterSubscriptionForm.value).emailAdress
  const recaptchaToken = await getRecaptchaToken(config.public.recaptchaSiteKey)
  if (await newsletterSubscribe(config.public.bridgeSiteUrl, locale.value, emailAddress, recaptchaToken, props.origin, props.endpointPath)) {
    emit('newsletter-subscribed')
    window.location.href = props.url
  }
}
</script>

<style scoped lang="scss"></style>
